import React from "react";
import Popup from "../../Popup";
import Button from "../../../UI/Button";
import "./index.scss";

export const RescheduleConfirm = ({ handleModal, rescheduleTheJob }) => {

    const rescheduleJob = async () => {
        await rescheduleTheJob();
        handleModal();
    }

    return (
        <Popup 
            closePopup={handleModal}
            title='Confirm your action'
        >
            <div className="reschedule-popup_desc">
                <p>Rescheduling this job inside of the 24-hour period will result in full payment of this scheduled appointment.</p>
            </div>
            <div className="reschedule-popup_footer">
                <Button text="Cancel" onClick={handleModal} type="cancel" />
                <Button text="Confirm Reschedule" onClick={rescheduleJob} type="primary reschedule"/>
            </div>
        </Popup>
    )
}